import React, { Fragment } from 'react';
import Header from '@components/Header';
import Footer from '@components/Footer';
import { graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { snakeCase } from 'lodash';
import { css } from '@emotion/react';
import { createUtmQuery } from '@lib/searchQuery';
import FrontpageLink from '@components/FrontpageLink';
import BackgroundImage from 'gatsby-background-image';
import PageTitle from '@components/ui/PageTitle';
import CtaButton from '@components/ui/CtaButton';
import TestimonialBlock from '@components/ui/TestimonialBlock';
import Hero from '@theme/components/Hero';

const utmMedium = 'testemonials';

export default function TestimonialsTemplate({
  data: {
    page: {
      testimonials: {
        link,
        title,
        testimonials
      }
    }
  },
  pageContext: { language, refs, layouts }
}) {
  return (
    <Fragment>
      <Hero title={title} divider={{ variant: 1, reflect: true }}>
        <Header
          language={language}
          refs={refs}
          layouts={layouts}
        />
      </Hero>
      <div className='container mb-5 pb-5 mt-5'>
        {testimonials.map((testimonial, index) =>
          <TestimonialBlock key={index} testimonial={testimonial} />
        )}
        <CtaButton link={link} utmMedium={utmMedium} utmContent="cta_button_testimonials" />
      </div>
      <Footer
        language={language}
        layouts={layouts}
      />
    </Fragment>
  );
}

export const query = graphql`
  query($testimonialsId: Int) {
    page: wordpressWpCustompages(wordpress_id: { eq: $testimonialsId }) {
      id
      acf {
        language
      }
      testimonials: childWordPressAcfTestimonialsSection {
        title
        link {
          link_url
          link_text
        }
        testimonials {
          name
          author_name
          author_profession
          text
          image {
            localFile {
              sharp: childImageSharp {
                fixed(width: 160, height: 160) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
          author_image {
            localFile {
              sharp: childImageSharp {
                fixed(width: 160, height: 160) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`;